module.exports = __webpack_public_path__ + "img/19-detail.37f25bca.png";